import Enum from '@/zenky/interfaces/common/Enum';
import DateTime from '@/zenky/interfaces/common/DateTime';
import ExternalIdentifier from '@/zenky/interfaces/common/ExternalIdentifier';
import Gender from '@/zenky/interfaces/customers/Gender';
import Phone from '@/zenky/interfaces/common/Phone';
import { Omit } from 'lodash';

export interface CustomerV2 {
  id: string;
  store_profile_id: string;
  first_name: string;
  last_name: string;
  full_name: string;
  phone: Phone;
  gender: Enum<Gender>;
  birth_date: DateTime | [];
  created_at: DateTime;
  updated_at: DateTime;
  external_identifier?: ExternalIdentifier;
};

export interface CustomerV3 extends Omit<CustomerV2, 'birth_date'> {
  birth_date: Exclude<CustomerV2['birth_date'], []> | null;
}

type Customer = CustomerV2;
export default Customer;

/* eslint-disable no-param-reassign */
export function v2ToV3(customerV2: CustomerV2) {
  if (Array.isArray(customerV2.birth_date)) {
    (customerV2 as unknown as CustomerV3).birth_date = null;
  }
}
/* eslint-enble no-param-reassign */
